__turbopack_context__.v({
  "background": "Newsletter-module-scss-module__quCLyG__background",
  "form__input": "Newsletter-module-scss-module__quCLyG__form__input",
  "form__message": "Newsletter-module-scss-module__quCLyG__form__message",
  "form__submit_button": "Newsletter-module-scss-module__quCLyG__form__submit_button",
  "inner": "Newsletter-module-scss-module__quCLyG__inner",
  "inner_form": "Newsletter-module-scss-module__quCLyG__inner_form",
  "inner_header": "Newsletter-module-scss-module__quCLyG__inner_header",
  "inner_text": "Newsletter-module-scss-module__quCLyG__inner_text",
  "loading_indicator": "Newsletter-module-scss-module__quCLyG__loading_indicator",
  "newsletter": "Newsletter-module-scss-module__quCLyG__newsletter",
});
